/**
 * Resource authoring inside the super admin console.
 *
 * Same component the platform admin uses at /admin/resource-content — mounted
 * with the super admin's API client so requests carry the super_admin token
 * instead of a portal one. Sharing the component rather than copying it means
 * the two consoles can't drift apart as the authoring form grows.
 *
 * The backend guard (require_resource_author in app/routers/resources.py) is
 * what actually permits this; a tenant's org_admin is refused on both doors.
 */
import AdminResourceContentPage from "@/pages/AdminResourceContent";

import { superAdminApi } from "./session";

export default function SuperAdminResourcesPage() {
  return <AdminResourceContentPage client={superAdminApi} />;
}
